// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2QONi","noInteraction":"EventWrapper_noInteraction__2hwRP"};